module.exports = __webpack_public_path__ + "img/bg-desktop.b2cf7d30.png";